import { parse } from "bcp-47";
import { Context } from "./context";

export function getDefaultLang(): string | null | undefined {
    //常规浏览器语言和IE浏览器
    const schema = parse(navigator.language || (navigator as any).userLanguage);
    return schema.language;
}

export enum Lang {
    En = "en",
    Zh = "zh",
}

export interface Text {
    en: string | JSX.Element;
    zh: string | JSX.Element;
}

export function T(text: Text): JSX.Element {
    return (
        <Context.Consumer>
            {(context) => {
                return text[context.lang];
            }}
        </Context.Consumer>
    );
}

export const COMMON = {
    OK: {
        en: "Ok",
        zh: "确定",
    },
    CANCEL: {
        en: "Cancel",
        zh: "取消",
    },
    ADD: {
        en: "Add",
        zh: "添加",
    },
    MODIFY: {
        en: "Modify",
        zh: "修改",
    },
    DELETE: {
        en: "Delete",
        zh: "删除",
    },
    SAVE: {
        en: "Save",
        zh: "保存",
    },
    RETURN: {
        en: "Return",
        zh: "返回",
    },
    CLOSE: {
        en: "Close",
        zh: "关闭",
    },
    LOGOUT: {
        en: "Logout",
        zh: "退出",
    },
    FEEDBACK: {
        en: "Feedback",
        zh: "反馈",
    },
    ADD_SUCCESSFULLY: {
        en: "Add successfully",
        zh: "添加成功",
    },
    UPDATE_SUCCESSFULLY: {
        en: "Update successfully",
        zh: "更新成功",
    },
    SAVE_SUCCESSFULLY: {
        en: "Save successfully",
        zh: "保存成功",
    },
    DELETE_SUCCESSFULLY: {
        en: "Delete successfully",
        zh: "删除成功",
    },
    CONFIRM_DELETING: {
        en: "Are you sure to delete?",
        zh: "确定删除？",
    },
    CONFIRM_TITLE: {
        en: "Confirm",
        zh: "确认",
    },
    PROMPT_TITLE: {
        en: "Prompt",
        zh: "提示",
    },
    TIP_TITLE: {
        en: "Tip",
        zh: "提示",
    }
};